"use client"

import { useState } from "react"
import { DAPP_LINKS } from "@/lib/dapp-content"
import { FAQ_CATS, FAQS } from "@/lib/faq-data"

export function FaqView() {
  const [filter, setFilter] = useState<(typeof FAQ_CATS)[number]>("ALL")
  const [open, setOpen] = useState(0)

  const visible = filter === "ALL" ? FAQS : FAQS.filter((f) => f.cat === filter)

  return (
    <div className="faq-wrap">
      <div className="faq-side">
        <h2>
          FAQ <span className="accent">/_Queries</span>
        </h2>
        <p className="sub">// {FAQS.length} KNOWLEDGE VECTORS · CATEGORIZED · GREP_ENABLED</p>
        <div className="faq-filter-label">// FILTER · CATEGORY</div>
        <div className="filters">
          {FAQ_CATS.map((c) => {
            const ct = c === "ALL" ? FAQS.length : FAQS.filter((f) => f.cat === c).length
            return (
              <button
                key={c}
                type="button"
                className={`filt ${filter === c ? "active" : ""}`}
                onClick={() => {
                  setFilter(c)
                  setOpen(0)
                }}
              >
                <span>$ {c}</span>
                <span className="ct">[{ct}]</span>
              </button>
            )
          })}
        </div>
        <p className="faq-filter-legend">
          <strong>LIVE</strong> = shipping today · <strong>LOTTERY</strong> = weekly ticket pools · <strong>RIFT</strong> = Data Rift daily board ·{" "}
          <strong>BADGES</strong> = vault collectibles + optional equipped passives · <strong>GOVERNANCE</strong> = Active Score + DAO voting ·{" "}
          <strong>CLANS</strong> = faction-aligned squads · <strong>LORE</strong> = narrative flavor, not extra rules.
        </p>
        <div className="stat-block">
          <div className="stat-block-title">// SESSION_INFO</div>
          <div className="row">
            <span>SESSION_ID</span>
            <span className="v">RVU_4f9a2c</span>
          </div>
          <div className="row">
            <span>UPTIME</span>
            <span className="v">99.998%</span>
          </div>
          <div className="row">
            <span>QUERIES_RESOLVED</span>
            <span className="v ok">
              {visible.length} / {visible.length}
            </span>
          </div>
          <div className="row">
            <span>SUPPORT</span>
            <span className="v">SUPPORT@RIVYU.XYZ</span>
          </div>
          <div className="stat-block-foot">◆ CLICK ANY LINE BELOW TO EXPAND_</div>
        </div>
      </div>
      <div className="faq-terminal">
        <div className="faq-term-head">
          <span className="dot" style={{ background: "#c9a96a" }} />
          <span className="dot" style={{ background: "#00e5ff" }} />
          <span className="dot" style={{ background: "#8fbfa8" }} />
          <span style={{ marginLeft: 8 }}>RIVYU.SUPPORT — root@queries — bash</span>
          <span className="right">
            ● {visible.length} ROWS · {filter}
          </span>
        </div>
        <div className="faq-term-body">
          <div className="faq-help-line">
            <span style={{ color: "var(--text-faint)" }}>$</span> rivyu --help{" "}
            <span style={{ color: "var(--text-faint)" }}>// retrieving knowledge_base</span>
          </div>
          {visible.map((f, i) => {
            const isOpen = open === i
            const realIdx = FAQS.indexOf(f)
            return (
              <div className="faq-row" key={`${f.q}-${i}`}>
                <button type="button" className={`faq-q-line ${isOpen ? "open" : ""}`} onClick={() => setOpen(isOpen ? -1 : i)}>
                  <span className="num">[{String(realIdx + 1).padStart(2, "0")}]</span>
                  <span className="prompt">$</span>
                  <span className="qtext">{f.q}</span>
                  <span className="faq-pills">
                    <span className="faq-cat-pill">{f.cat}</span>
                    {f.status === "planned" ? <span className="faq-status-pill planned">PLANNED</span> : null}
                  </span>
                  <span className="caret">+</span>
                </button>
                {isOpen && (
                  <div className="faq-a-block">
                    <span className="aprompt">»</span>
                    {f.a}{" "}
                    {f.botLink && (
                      <a href={DAPP_LINKS.telegramBot} className="faq-inline-link" target="_blank" rel="noreferrer">
                        Open bot ↗
                      </a>
                    )}
                  </div>
                )}
              </div>
            )
          })}
          <div className="faq-help-line" style={{ marginTop: 16 }}>
            <span style={{ color: "var(--text-faint)" }}>$</span> <span className="faq-cursor" />
          </div>
        </div>
      </div>
    </div>
  )
}
